import Axios from 'axios';

const http = Axios.create({
  withCredentials: true,
});

export default http;
